module.exports = __webpack_public_path__ + "static/media/3.122a4cf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Hero/3.jpg
// module id = 252
// module chunks = 0